import { FC, PropsWithChildren, ReactNode } from 'react';
import { Layout, LoadingSpinner } from '@repo/atomic-components';
import { Header } from './Header';

type MedicalRecordsTemplate = PropsWithChildren<{
  isDataLoading: boolean;
  actionsPanel: ReactNode;
  content: ReactNode;
}>;

export const MedicalRecordsTemplate: FC<MedicalRecordsTemplate> = ({ isDataLoading, actionsPanel, content }) => {
  return (
    <Layout>
      <div className="grid h-full w-full grid-cols-[1fr] grid-rows-[48px_64px_1fr] gap-0">
        <div className="order-0 col-span-full">
          <Header />
        </div>

        <div className="order-2 col-span-full">{actionsPanel}</div>

        <div className="order-4 col-span-full h-full w-full overflow-hidden">
          {isDataLoading ? <LoadingSpinner /> : content}
        </div>
      </div>
    </Layout>
  );
};
